import useMatchMedia from '@/hooks/useMatchMedia';

import PageHead from '@/components/common/PageHead';
import ClientOnly from '@/components/common/ClientOnly';
import Container from '@/components/common/Container';
import Section from '@/components/common/Section';
import Heading from '@/components/common/Heading';
import Box from '@/components/common/Box/Box';

import ServicesLayout from '@/components/Pages/Services/ServicesLayout';
import Info from '@/components/Pages/Index/Info';
import ServicesBlock from '@/components/Pages/Services/ServicesBlock';
import FAQs from '@/components/Pages/Index/FAQs';
import InnerHero from '@/components/InnerHero/InnerHero';
import BackgroundHero from '@/components/common/Background/BackgroundHero';

import info from '@/db/about/aboutInfo.json';
import webdesignBlock from '@/db/about/aboutBlock.json';
import faqs from '@/db/about/aboutFaqs.json';
import innerHero from '@/db/about/aboutHero.json';
import aboutMeta from '@/db/about/aboutMeta.json';

const AboutUs = () => {
  const { isMobile } = useMatchMedia();
  return (
    <>
      <PageHead {...aboutMeta} />
      <Box className=" relative">
        <Container>
          <Section className="pt-0 pb-0 lg:pb-4">
            <InnerHero innerHero={innerHero} />
          </Section>
        </Container>
        <BackgroundHero />
      </Box>

      <Container>
        <Section>
          <Heading headingLevel="h2" className="text-center mb-[40px]">
            How can we help
          </Heading>
          <ServicesBlock webdesignBlock={webdesignBlock} />
        </Section>
      </Container>

      <Container>
        <Section className="px-0 md:px-[50px]">
          <Heading headingLevel="h2" className=" text-center mb-5 md:mb-16">
            About Code Solution
          </Heading>
          <Info info={info} />
        </Section>
      </Container>

      <Container>
        <Section>
          <Heading headingLevel="h2" className="text-center mb-5 md:mb-16">
            <ClientOnly>
              {isMobile ? 'FAQs' : 'Frequently Asked Questions'}
            </ClientOnly>
          </Heading>
          <FAQs faqs={faqs} />
        </Section>
      </Container>
    </>
  );
};

AboutUs.PageLayout = ServicesLayout;

export default AboutUs;
